import { NationalTransferQueryService } from "../../../services/payments/NationalTransferQueryService";
import { NationalTransferModel } from "../../models/NationalTransfer";
import { IQueryNationalTransferRepository } from "../../ports/payments/IQueryNationalTransferRepository";
import Query from "../Query";

class NationalTransferQuery
  extends Query<NationalTransferModel>
  implements IQueryNationalTransferRepository
{
  constructor(public queryService: NationalTransferQueryService) {
    super(queryService);
  }
}

export default NationalTransferQuery;
